<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>展会设置</BreadcrumbItem>
          <BreadcrumbItem>企业动态</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">企业动态</div>
        <Input search placeholder="请输入关键字" v-model="search" @on-search="init" style="width:230px;margin-top:20px;" />
      </div>
      <div class="header-tool-box">
        <div class="htb-item" :disabled-hover="false" @click="$router.push('/host/index/set/Exnewsadd')">
          <span class="htb-add">+</span>
          <span>添加动态</span>
        </div>
      </div>
    </div>

    <div class="my-item">
      <template v-if="newsList && newsList.length">
        <Row :gutter="30">
          <Col style="width:20%;float:left" v-for="(item, index) in newsList" :key="index">
          <div class="my-item-box">
            <div class="mi-top">
              <img :src="item.coverUrl" v-if="item.coverUrl" />
              <img src="@assets/img/empty.png" v-else />
              <span class="mi-top-count" v-if="item.ClickCount">点击量: {{item.ClickCount}}</span>
            </div>
            <div class="mi-title f-tac" :title="item.title">{{item.title}}</div>
            <div class="mi-tool">
              <div class="mi-tool-item z-primary" @click="showEdit(item)">编辑</div>
              <div class="mi-tool-line">|</div>
              <div class="mi-tool-item z-primary" v-if="item.isShow" @click="setIsShow(item,false)">隐藏</div>
              <div class="mi-tool-item z-primary" v-else @click="setIsShow(item,true)">显示</div>
              <div class="mi-tool-line">|</div>
              <div class="mi-tool-item">
                <Poptip confirm placement="top-start" title="确认删除此动态吗 ?" @on-ok="delItem(item)" @on-cancel="handleClose()">删除</Poptip>
              </div>
            </div>
          </div>
          </Col>
        </Row>
        <div class="my-page" v-if="totalCount > pageSize">
          <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount" @on-change="changePage" @on-page-size-change="changePageSize" />
        </div>
      </template>
      <div class="u-empty" v-else>暂无数据！</div>
    </div>

  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "project-set",
  data() {
    return {
      search: "",
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      newsList: [],
    };
  },
  components: {},
  computed: {},
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getNews: "hostAuditModule/getNews",
      delExNews: "hostAuditModule/delExNews",
      setNews: "hostAuditModule/setNews",
    }),
    async init() {
      let list = await this.getNews({
        show: 1,
        value: {
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
          Wheres: {
            type: 0,
            wheres: {
              WhereGroupOperator: 0,
              Predicates: [
                {
                  type: 1,
                  wheres: {
                    WhereOperator: 6,
                    Label: "title",
                    Value: "%" + this.search + "%",
                  },
                },
              ],
            },
          },
        },
      });
      this.newsList = list.items;
      this.pageSize = list.pageSize;
      this.pageIndex = list.pageIndex;
      this.totalCount = list.totalCount;
    },
    showEdit(e) {
      this.$router.push("/host/index/set/Exnewsedit?id=" + e.id);
    },
    handleClose() {},
    async delItem(e) {
      let bool = await this.delExNews(e.id);
      if (bool && bool.successed) {
        this.$Message.success("操作成功！");
        this.init();
      } else {
        this.$Message.error("操作失败，请重试！");
      }
    },
    async setIsShow(item, e) {
      let bool = await this.setNews({
        id: item.id,
        isShow: e,
      });
      if (bool.successed) {
        this.init();
        this.$Message.success("操作成功！");
      } else {
        this.$Message.error("操作失败，请重试！");
      }
    },
    changePage(e) {
      window.scroll(0, 0);
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      window.scroll(0, 0);
      this.pageSize = e;
      this.init();
    },
  },
};
</script>

<style scoped lang="scss">
.my-page {
  text-align: center;
}
.mi-top-count {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #ccc;
  color: #000;
  z-index: 100;
  padding: 2px 10px;
  font-size: 14px;
}
</style>

